import carIcon from './extensions/domiCar/domi-car.svg';
import robotDogIcon from './extensions/domiRobotDog/domi-robot-dog.svg';
import domiAiRoundIcon from './extensions/domiAiRound/domi-ai-round.svg';
import microbitIcon from './extensions/microbit/microbit-illustration.svg';

import domiAiRoundExamples from './domi-ai-round-examples.js';
import domiCarExamples from './domi-car-examples.js';
import domiRobotDogExamples from './domi-robot-dog-examples.js';

const hardwareExampleDevices = [{
    id: 'domi-car',
    extensionId: 'domiCar',
    title: {
        id: 'gui.domiExamples.device.domiCar.title',
        defaultMessage: 'Domi Car'
    },
    description: {
        id: 'gui.domiExamples.device.domiCar.description',
        defaultMessage: 'Drive, lights, camera and offline routes'
    },
    icon: carIcon,
    examples: domiCarExamples,
    available: true,
    help: {
        id: 'gui.domiExamples.safety.car',
        defaultMessage: 'Loading an example will not start the car. Connect the car, then click the green flag ' +
            'or trigger its event.'
    }
}, {
    id: 'domi-robot-dog',
    extensionId: 'domiRobotDog',
    title: {
        id: 'gui.domiExamples.device.robotDog.title',
        defaultMessage: 'Domi Quadruped Robot'
    },
    description: {
        id: 'gui.domiExamples.device.robotDog.description',
        defaultMessage: 'Movement, poses and talent shows'
    },
    icon: robotDogIcon,
    examples: domiRobotDogExamples,
    available: true,
    help: {
        id: 'gui.domiExamples.safety.robotDog',
        defaultMessage: 'Join the quadruped robot Wi-Fi and connect in the Device pane, then click the green flag. ' +
            'The preview is an illustration. A running physical action may finish before Stop takes effect.'
    }
}, {
    id: 'domi-ai-round',
    extensionId: 'domiAiRound',
    title: {
        id: 'gui.domiExamples.device.domiAiRound.title',
        defaultMessage: 'Domi AI Round'
    },
    description: {
        id: 'gui.domiExamples.device.domiAiRound.description',
        defaultMessage: 'Display, touch and interactive games'
    },
    icon: domiAiRoundIcon,
    examples: domiAiRoundExamples,
    available: true,
    help: {
        id: 'gui.domiExamples.safety.round',
        defaultMessage: 'Keep the round screen connected by USB. First click the standalone connect block at the top ' +
            'left, allow serial access, then click the green flag.'
    }
}, {
    id: 'microbit',
    extensionId: 'microbit',
    title: {
        id: 'gui.domiExamples.device.microbit.title',
        defaultMessage: 'micro:bit'
    },
    description: {
        id: 'gui.domiExamples.device.microbit.description',
        defaultMessage: 'LED, buttons, gestures and sensors'
    },
    icon: microbitIcon,
    examples: [],
    available: false
}];

export default hardwareExampleDevices;
